export default {"src":"/_next/static/media/twitter-icon.07021941.svg","height":46,"width":49,"blurWidth":0,"blurHeight":0};